export default __webpack_public_path__ + "static/media/main_coffee_cup_01.ed18e814.webp";